import { createTheme } from "@mui/material/styles";
import { useRef, useState } from "react";
import { DateInput } from "./DateInput";
type InputProps = {
    title?: string;
    checkboxTitle?: string;
    checkboxNotClickable?: boolean;
    type?:
    | "text"
    | "radio"
    | "checkbox"
    | "textarea"
    | "number"
    | "email"
    | "password"
    | "date"
    | "time"
    | "card"
    | "address";
    placeholder?: string;
    name?: string;
    onChangeFunction?: (arg0: string) => void;
    options?: { name: string, value?: string }[];
    className?: string;
    inputClassName?: string;
    titleClassname?: string;
    editing?: boolean;
    textBoxClass?: string;
    value?: string | number;
    isChecked?: boolean;
    isDisabled?: boolean;
    children?: JSX.Element | false | undefined;
    style?: any;
    uri?: string;
    titleWrap?: boolean;
    single_day_value?: string[];
    handle_single_day?: (value: any) => void;
    hidden?: boolean;
    radioDivClassname?: string;
};
function Input({
    title,
    checkboxTitle,
    checkboxNotClickable,
    type = "text",
    placeholder,
    name = "",
    onChangeFunction,
    options,
    className,
    inputClassName,
    titleClassname,
    editing,
    textBoxClass,
    value = "",
    isChecked = false,
    isDisabled,
    children,
    style,
    uri,
    titleWrap = false,
    hidden,
    radioDivClassname,
}: InputProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [check, setCheck] = useState(true);
    const theme = createTheme({
        components: {},
    });
    const datePicker = useRef<HTMLInputElement>(null);
    return (
        <div className={`flex ${className ? className : " flex-col"} ${hidden && "hidden"}`}>
            {title && (
                <div
                    className={`${!titleWrap && "whitespace-nowrap"} text-r-medium-small-2 text-color7 ${titleClassname ? titleClassname : ""
                        }`}
                >
                    {title}
                </div>
            )}
            {type === "radio" && options && options.length > 0 ? (
                <div className={radioDivClassname || "form-radio-button"}>
                    {options.map((option) => {
                        return (
                            <div className="flex items-center gap-2" key={name + option.name}>
                                <input
                                    disabled={editing === false}
                                    className={editing === false ? " !bg-color15 !text-color1" : " bg-color8"}
                                    type="radio"
                                    name={title}
                                    id={name + option.name}
                                    onChange={(e) => {
                                        onChangeFunction && onChangeFunction(e.target.value);
                                    }}
                                    checked={option.value === value || option.name === value}
                                    value={option.value || option.name}
                                    autoComplete="off"
                                />
                                <label
                                    className={
                                        "font-inter capitalize text-r-medium-small-2 text-color7 " + inputClassName
                                    }
                                    htmlFor={name + option.name}
                                >
                                    {option.name}
                                </label>
                            </div>
                        );
                    })}
                </div>
            ) : type === "checkbox" ? (
                <label className="flex items-center gap-2 font-inter text-color7 text-r-medium-small-2">
                    <input
                        name={name}
                        className={`outline-none text-color7  ${!editing ? " bg-color15 text-color1"  : " bg-color8"
                            } rounded-[7px] !border-color3 focus:ring-color1 focus:border-color1 transition-all ${inputClassName ? inputClassName : ""
                            } `}
                        type={type}
                        placeholder={placeholder}
                        onChange={(e) => {
                            onChangeFunction && onChangeFunction(e.target.value);
                        }}
                        disabled={editing === false || checkboxNotClickable === true}
                        value={value && value}
                        checked={isChecked}
                        style={{ ...style }}
                    />
                    {checkboxTitle}
                </label>
            ) : type === "textarea" ? (
                <span
                    contentEditable={editing}
                    role="textbox"
                    className={
                        (textBoxClass
                            ? textBoxClass
                            : "border border-color3 bg-color8 rounded-[7px] py-1 px-2 focus:ring-color1 focus:border-color7 ") +
                        (editing === false ? " !bg-color15 !text-color1" : "")
                    }
                    onChange={(e) => {
                        onChangeFunction &&
                            onChangeFunction((e.target as HTMLSpanElement).innerText);
                    }}
                >
                    {value && value}
                </span>
            ) : type === "date" ? (
                <div className="flex flex-col relative w-full gap-1">
                    <DateInput
                        onChange={onChangeFunction!}
                        className={className}
                        inputClassName={inputClassName}
                        titleClassname={titleClassname}
                        editing={editing}
                        emptyValue={""}
                        val={value as string}
                    />
                </div>
            ) : type === "card" ? (
                <div
                    className={`flex flex-row outline-none text-color7 h-[34px] border-color3 overflow-hidden border text-r-medium-small-2 focus:ring-color1
                        focus:border-color1 transition-all rounded-[7px]
                         ${!editing && " bg-color15 text-color1"}`}
                >
                    <img src={uri} alt="" className={"py-2 px-2"} />
                    <input
                        name={name}
                        style={style}
                        type={"text"}
                        className={`outline-none w-full border-none ${!editing && " bg-color15 text-color1"
                            } ${inputClassName ? inputClassName : " bg-color8"}`}
                        onFocus={(e) => {
                            setCheck(false);
                        }}
                        onBlur={(e) => {
                            setCheck(true);
                        }}
                        placeholder={placeholder}
                        onChange={(e) => {
                            onChangeFunction?.(e.target.value);
                        }}
                        disabled={editing === false}
                        value={value && value}
                    />
                </div>
            ) : (
                <input
                    name={name}
                    style={style}
                    className={`outline-none text-color7 border-color3 h-[34px] text-r-medium-small-2 focus:ring-color1
                        focus:border-color1 transition-all rounded-[7px] py-1 px-2
                        ${inputClassName ? inputClassName : "bg-color8"} ${editing === false ? " !bg-color15 !text-color1" : ""
                        } `}
                    type={type === "address" ? "text" : type}
                    data-address={type === "address"}
                    onFocus={(e) => {
                        setCheck(false);
                    }}
                    onBlur={(e) => {
                        setCheck(true);
                    }}
                    placeholder={placeholder}
                    onChange={(e) => {
                        onChangeFunction?.(e.target.value);
                    }}
                    disabled={editing === false}
                    value={value && value}
                    step={"0.01"}
                />
            )}
            {/* You can pass a component to display stuff under the input. Its usually used for
                displaying error msges */}
            {children && children}
        </div>
    );
}

export default Input;
